module.exports = __webpack_public_path__ + "Alvin Kowk-5164bbfe.png";